import { phonePrefix } from "../data/country";

/** Normalizes Turkish I-variants (I, İ, i, ı) to a common form so that
 *  typing "Is" matches "İsmayıllı". Use as the `filterOption` prop on Ant Design Select. */
export const selectFilterOption = (input: string, option?: { label?: unknown }) => {
    const normalize = (s: string) => s.replace(/İ/g, 'I').replace(/ı/g, 'i').toLowerCase();
    return normalize(String(option?.label ?? '')).includes(normalize(input));
};

export const convertPhoneNumber = (phoneNumber: string): string => {
    return phoneNumber?.includes(phonePrefix) ? phoneNumber : phonePrefix + phoneNumber;
}

export const parseStringToDecimal = (str: string) => {
    return Number(str?.replace(",", '.'));
}

export const parseNumberToString = (n: number) => {
    let str = String(n)?.replace(".", ",")
    if (str?.endsWith(",0")) str = str?.replace(",0", "");
    return str;
}

export const isDecimal = (value: string) => value === "" || /^\d+(,\d{0,2})?$/.test(value);

export const deepEqual = <T>(obj1: T, obj2: T): boolean => {
    if (obj1 === obj2) return true;

    if (
        typeof obj1 !== 'object' || obj1 === null ||
        typeof obj2 !== 'object' || obj2 === null
    ) {
        return false;
    }

    const keys1 = Object.keys(obj1 as object);
    const keys2 = Object.keys(obj2 as object);

    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
        if (!keys2.includes(key)) return false;

        const val1 = (obj1 as any)[key];
        const val2 = (obj2 as any)[key];

        if (!deepEqual(val1, val2)) return false;
    }

    return true
}

export const hasCommonValue = <T>(array1: T[], array2: T[]) => {
    const set1 = new Set(array1);
    return array2.some((value: any) => set1.has(value));
}